import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { api } from '@consts/url.const';
import { ShareableGroupsSyncModel } from '@models/shareable-groups-sync.model';

@Injectable({ providedIn: 'root' })
export class ShareableGroupsSyncService {
  constructor(private readonly http: HttpClient) {}

  public triggerPersonSync(): Observable<ShareableGroupsSyncModel.TriggerResponse> {
    return this.http.post<ShareableGroupsSyncModel.TriggerResponse>(
      api.shareableGroupsSync.triggerPersonSync,
      {},
    );
  }

  public triggerVehicleSync(): Observable<ShareableGroupsSyncModel.TriggerResponse> {
    return this.http.post<ShareableGroupsSyncModel.TriggerResponse>(
      api.shareableGroupsSync.triggerVehicleSync,
      {},
    );
  }

  public getSyncLogs(limit: number): Observable<ShareableGroupsSyncModel.GroupSyncLogEntry[]> {
    return this.http
      .get<ShareableGroupsSyncModel.GroupSyncLogEntry[]>(api.shareableGroupsSync.logs, {
        params: { limit: limit.toString() },
      })
      .pipe(map((logs) => logs.map((log) => ({ ...log, createdAt: new Date(log.createdAt) }))));
  }

  public getSyncStats(): Observable<ShareableGroupsSyncModel.GroupSyncStats> {
    return this.http.get<ShareableGroupsSyncModel.GroupSyncStats>(api.shareableGroupsSync.stats);
  }
}
